import axios from "axios";

import { BASE_URL } from "../../../constant";
import {
    handleFormatResponse,
    handleFormatResponseForError,
} from "../../../utility";

export const useAffiliateGroupData = () => {
    const getAffiliateGroupData = async (url: string) => {
        try {
            let response = await axios.get(`${BASE_URL}affiliate-group${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const postAffiliateGroupData = async (url: string, payload: any) => {
        try {
            let response;
            if (payload == null) {
                response = await axios.post(`${BASE_URL}affiliate-group${url && url}`)
            } else {
                response = await axios.post(`${BASE_URL}affiliate-group${url}`, payload)
            };
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const putAffiliateGroupData = async (url: string, payload: any) => {
        try {
            let response = await axios.put(`${BASE_URL}affiliate-group${url && url}`, payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const patchAffiliateGroupData = async (url: string, payload?: any) => {
        try {
            let response = await axios.patch(`${BASE_URL}affiliate-group${url && url}`, payload && payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const deleteAffiliateGroupData = async (url: string) => {
        try {
            let response = await axios.delete(`${BASE_URL}affiliate-group${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };


    return {
        getAffiliateGroupData,
        postAffiliateGroupData,
        putAffiliateGroupData,
        patchAffiliateGroupData,
        deleteAffiliateGroupData
    };

};